//  ----------      START   IMPORT  BLOCK       ----------
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
//  Widgets
import QRWithLogo from "../../Utils/qrWithLogo";
//  Services
import GeneralInfoService from "../../API/Services/GeneralInfoService";
//  Context
import { useLanguage } from "../../API/Context/LanguageContext";
//  Config
import VocabRquestAllowance from "../../ConfigFiles/multilingual/VocabRequestAllowance";
import { FRONTEND_ROUTES } from "../../ConfigFiles/Routes/frontend_routes";
//  ----------      END   IMPORT  BLOCK       ----------

const RequestAllowanceWidget = ({  }) => {
  //  Consume context
  const { lan } = useLanguage()

  //  Get username from URL
  const { username } = useParams();
  //  To be displayed
  const [fullName, setFullName] = useState("");
  //  Will route here if no name is available.
  const default_destination = FRONTEND_ROUTES.SERVER + FRONTEND_ROUTES.invited_static
  const [destinationLink, setDestinationLink] = useState(default_destination);


  useEffect(() => {
    const service = new GeneralInfoService();
    console.log('username', username)
    setDestinationLink(FRONTEND_ROUTES.SERVER + FRONTEND_ROUTES.invited_static + '/' + username)

    if (username) {
      //  Param exists
      service.readFullName(username)
        .then((res) => {
          //  API returns full_name:
          setFullName(res);
        })
        .catch((err) => {
          console.error("Failed to fetch full name:", err);
          //  Fallback to raw username
          setFullName(username);
        });
    } else {
      //  Fallback to dummy profile.
      setFullName("Guest User");
      setDestinationLink(default_destination)
    }
  }, [username]);

  return (
    <div className="container mt-4">
        <QRWithLogo size={250} data={destinationLink} lan={lan} message={VocabRquestAllowance.scan_me[lan].replace("{variable}", fullName)}/>
    </div>
  );
};

export default RequestAllowanceWidget;
